// extracted by mini-css-extract-plugin
export default {"item":"MultilingualSection_item__rsbH8"};